package br.com.texeratx.boardgametimeapp.core.spotify.auth

class SpotifyAuthException(
    val reason: Reason,
    message: String
) : Exception(message) {
    enum class Reason {
        RECONNECT_REQUIRED,
        GENERIC_AUTH_FAILURE
    }
}
